/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { lazy, object, Schema, string } from '../schema';
import { Account1, account1Schema } from './account1';

export interface Account {
  accountId: string;
  currency: string;
  nickname: string;
  description: string;
  accountType: string;
  accountSubType: string;
  account: Account1;
}

export const accountSchema: Schema<Account> = object({
  accountId: ['AccountId', string()],
  currency: ['Currency', string()],
  nickname: ['Nickname', string()],
  description: ['Description', string()],
  accountType: ['AccountType', string()],
  accountSubType: ['AccountSubType', string()],
  account: ['Account', lazy(() => account1Schema)],
});
